import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-distribution-preproject-kit',
  templateUrl: './distribution-preproject-kit.component.html',
  styleUrls: ['./distribution-preproject-kit.component.scss']
})
export class DistributionPreprojectKitComponent implements OnInit {

  materiales: { id: number , nombre: string}[] = [];
  paginas:any;

  constructor(
    public dialogRef: MatDialogRef<DistributionPreprojectKitComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.materiales = this.data.materiales.sort((a:any, b:any) => a.nombre.localeCompare(b.nombre));
    this.paginas = Array.from(
      { length: this.data.paginas },
      (_, i) => ({
        pagina: i + 1,
        materialId: null
      })
    );
  }

  guardar() {

      const haySinSeleccionar = this.paginas.some(
        (pagina:any) => pagina.materialId == null || pagina.materialId === ''
      );

      if (haySinSeleccionar) {
        Swal.fire({
          icon: 'warning',
          title: 'Faltan datos',
          text: 'Debe seleccionar un nombre operativo para todas las páginas.'
        });
        return;
      }

      else{
        const data = this.paginas.map((p:any) => ({
          pagina: p.pagina,
          materialId: p.materialId,
          nombre: this.materiales.find(m => m.id == p.materialId)?.nombre
        }));

        this.dialogRef.close(data);
      }
      
  }

  cancelar(): void {
    this.dialogRef.close();
  }

}
